import type { QueuedMessage } from '@/hooks/message-queue.util';
import { createContext, useContext } from 'react';

/**
 * The queue of the chat on screen, for the composer (see
 * useAgentChatRuntime). Its own context so the Thread, and a test, can read
 * it without the whole runtime provider.
 */
export type MessageQueue = {
  /** Oldest first. */
  items: readonly QueuedMessage[];
  /** Messages wait and nothing runs: they can go out now. */
  canSendNow: boolean;
  /** A confirmation card waits, so nothing else sends, as with Send. */
  sendDisabled: boolean;
  /** Sends the whole queue as one message. */
  sendNow: () => void;
  remove: (id: string) => void;
  /** Takes the message out of the queue; its text, for the composer. */
  edit: (id: string) => string | null;
};

export const MessageQueueContext = createContext<MessageQueue | null>(null);

/** The chat's queue, or null outside a provider. */
export const useMessageQueue = (): MessageQueue | null =>
  useContext(MessageQueueContext);
